import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetOrgDriversQueryVariables = Types.Exact<{
  where: Types.Drivers_Bool_Exp;
  orderBy?: Types.InputMaybe<Array<Types.Drivers_Order_By> | Types.Drivers_Order_By>;
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
}>;


export type GetOrgDriversQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', id: number, status: string, tax_class: string, driver_app_version?: string | null, phone_type?: string | null, config?: object | null, user_id?: number | null, home_location?: { __typename?: 'locations', address_line_one?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, timezone?: string | null } | null, user?: { __typename?: 'users', id: number, avatar_url?: string | null, active: boolean, display_name: string, email?: string | null, phone?: string | null, customer_id?: number | null, default_role: string, created_at: string } | null }> };


export const GetOrgDriversDocument = gql`
    query GetOrgDrivers($where: drivers_bool_exp!, $orderBy: [drivers_order_by!], $limit: Int!, $offset: Int!) {
  drivers(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    id
    status
    tax_class
    driver_app_version
    phone_type
    config
    user_id
    home_location {
      address_line_one
      city
      state
      zip_code
      timezone
    }
    user {
      id
      avatar_url
      active
      display_name
      email
      phone
      customer_id
      default_role
      created_at
    }
  }
}
    `;

/**
 * __useGetOrgDriversQuery__
 *
 * To run a query within a React component, call `useGetOrgDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgDriversQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetOrgDriversQuery(baseOptions: Apollo.QueryHookOptions<GetOrgDriversQuery, GetOrgDriversQueryVariables> & ({ variables: GetOrgDriversQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgDriversQuery, GetOrgDriversQueryVariables>(GetOrgDriversDocument, options);
      }
export function useGetOrgDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgDriversQuery, GetOrgDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgDriversQuery, GetOrgDriversQueryVariables>(GetOrgDriversDocument, options);
        }
// @ts-ignore
export function useGetOrgDriversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrgDriversQuery, GetOrgDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgDriversQuery, GetOrgDriversQueryVariables>;
export function useGetOrgDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgDriversQuery, GetOrgDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgDriversQuery | undefined, GetOrgDriversQueryVariables>;
export function useGetOrgDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgDriversQuery, GetOrgDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrgDriversQuery, GetOrgDriversQueryVariables>(GetOrgDriversDocument, options);
        }
export type GetOrgDriversQueryHookResult = ReturnType<typeof useGetOrgDriversQuery>;
export type GetOrgDriversLazyQueryHookResult = ReturnType<typeof useGetOrgDriversLazyQuery>;
export type GetOrgDriversSuspenseQueryHookResult = ReturnType<typeof useGetOrgDriversSuspenseQuery>;
export type GetOrgDriversQueryResult = Apollo.QueryResult<GetOrgDriversQuery, GetOrgDriversQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/drivers/queries/getOrgDrivers.query.gql}
 */
export async function getOrgDrivers(
  variables: GetOrgDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOrgDriversQuery['drivers']>
export async function getOrgDrivers(
  variables: GetOrgDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOrgDriversQuery>
export async function getOrgDrivers(
  variables: GetOrgDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOrgDriversQuery['drivers'] | GetOrgDriversQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOrgDriversQuery>(
    GetOrgDriversDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers
}